import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../_shared/shared.module';
import { OlMapComponent } from '../components/ol-map/ol-map.component';
import { AtlasFixMapComponent } from '../components/ol-map/components/atlas-fix-map/atlas-fix-map.component';
import { AtlasFtthMapComponent } from '../components/ol-map/components/atlas-ftth-map/atlas-ftth-map.component';
import { AtlasMobileMapComponent } from '../components/ol-map/components/atlas-mobile-map/atlas-mobile-map.component';
import { AtlasFixFilterComponent } from '../components/ol-map/ol-map-filters/components/atlas-fix-filter/atlas-fix-filter.component';
import { AtlasFtthFilterComponent } from '../components/ol-map/ol-map-filters/components/atlas-ftth-filter/atlas-ftth-filter.component';
import { AtlasMobileFilterComponent } from '../components/ol-map/ol-map-filters/components/atlas-mobile-filter/atlas-mobile-filter.component';
import { AtlasFixDescriptionComponent } from '../components/data-description/components/atlas-fix-description/atlas-fix-description.component';
import { AtlasFtthDescriptionComponent } from '../components/data-description/components/atlas-ftth-description/atlas-ftth-description.component';
import { AtlasMobileDescriptionComponent } from '../components/data-description/components/atlas-mobile-description/atlas-mobile-description.component';
import { AtlasFtthLegendComponent } from '../components/ol-map/ol-map-legend/components/atlas-ftth-legend/atlas-ftth-legend.component';
import { AtlasFixPageComponent } from '../pages/atlas-fix-page/atlas-fix-page.component';
import { AtlasFtthPageComponent } from '../pages/atlas-ftth-page/atlas-ftth-page.component';
import { AtlasMobilePageComponent } from '../pages/atlas-mobile-page/atlas-mobile-page.component';

const routes: Routes = [
    {
        path: '',
        component: OlMapComponent,
        children: [
            { path: 'ftth', component: AtlasFtthPageComponent },
            { path: 'mobile', component: AtlasMobilePageComponent },
            { path: 'landline', component: AtlasFixPageComponent },
            {
                path: 'trein',
                loadChildren: () => import('../treinmetingen/treinmetingen.module').then((m) => m.TreinmetingenModule),
            },
        ],
    },
];

@NgModule({
    declarations: [
        OlMapComponent,
        AtlasFixMapComponent,
        AtlasFtthMapComponent,
        AtlasMobileMapComponent,
        AtlasFixFilterComponent,
        AtlasFtthFilterComponent,
        AtlasMobileFilterComponent,
        AtlasFixDescriptionComponent,
        AtlasFtthDescriptionComponent,
        AtlasMobileDescriptionComponent,
        AtlasFtthLegendComponent,
        AtlasFixPageComponent,
        AtlasFtthPageComponent,
        AtlasMobilePageComponent,
    ],
    imports: [SharedModule, RouterModule.forChild(routes)],
})
export class AtlasModule {}
